function handleMouseEnter(index, hoverStates, setHoverStates) {
  const updatedHoverStates = [...hoverStates];
  updatedHoverStates[index] = true;
  setHoverStates(updatedHoverStates);
}

export default handleMouseEnter;
